import React from 'react'
import UserProfileCard from '../components/contact-card/Contact'

function ContactCard() {
  return (
    <div>
      <UserProfileCard />
    </div>
  )
}

export default ContactCard